import type { FeedbackManagerState } from 'owa-feedback-manager/lib/store/schema/FeedbackManagerState';
import type RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import type SubstrateSearchScenario from 'owa-search-service/lib/data/schema/SubstrateSearchScenario';
import createRecipientWell from './createRecipientWell';
import { tryGetDefaultMailboxInfo } from 'owa-recipient-common/lib/utils/tryGetDefaultMailboxInfo';

/**
 * This function is a wrapper around createRecipientWell that uses a empty mailboxInfo.
 * It does not work for multi-account. The support for empty userIdentity interpreted as primary
 * account userIdentity is at the discretion of the account ISX team and can break without notice.
 *
 * Call createRecipientWell with a valid mailboxInfo instead.
 */
export default function createEmptyRecipientWell(
    findPeopleFeedbackManager?: FeedbackManagerState,
    searchScenario?: SubstrateSearchScenario
): RecipientWellWithFindControlViewState {
    return createRecipientWell(
        tryGetDefaultMailboxInfo(),
        findPeopleFeedbackManager,
        searchScenario
    );
}
